import { createLitComponent } from "../lib/create-lit-component.js";
import { GivebutterGoalBar } from "@givebutter/widgets-core";
//#region src/components/GivebutterGoalBar.tsx
const GivebutterGoalBar$1 = createLitComponent({
	elementClass: GivebutterGoalBar,
	tagName: "givebutter-goal-bar"
});
//#endregion
export { GivebutterGoalBar$1 as GivebutterGoalBar };
